"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.contentType = void 0;

/* Path (in Lyearn) -> Course (for DA)
Course (in Lyearn) -> Topic (For DA)
ILT (in Lyearn) -> Lecture (For DA)
ILT Session (in Lyearn) -> Session (For DA)
Checkpoint (in Lyearn) -> Task (For DA) */
var typeAlternates = {
  course: {
    plural: 'courses',
    alternate: 'topic',
    alternatePlural: 'topics'
  },
  ilt: {
    plural: 'ilts',
    alternate: 'lecture',
    alternatePlural: 'lectures'
  },
  path: {
    plural: 'paths',
    alternate: 'course',
    alternatePlural: 'courses'
  },
  session: {
    plural: 'sessions',
    alternate: 'session',
    alternatePlural: 'sessions'
  },
  checkpoint: {
    plural: 'checkpoints',
    alternate: 'task',
    alternatePlural: 'tasks'
  },
  'checkpoint review': {
    plural: 'checkpoint reviews',
    alternate: 'task review',
    alternatePlural: 'task reviews'
  }
};

var getCase = function getCase(type, typeCase, plural) {
  var transformedType = '';

  if (typeCase === 'U') {
    // Uppercase
    transformedType = type.toUpperCase();
  } else if (typeCase === 'C') {
    // Capitalize
    transformedType = type.charAt(0).toUpperCase() + type.slice(1);

    if (transformedType.toLowerCase().indexOf('ilt') === 0) {
      transformedType = transformedType.toUpperCase();
    }
  } else {
    transformedType = type;
  }

  if (plural && plural.plural && plural.lowercaseS) {
    // last character lowercase
    transformedType = transformedType.slice(0, -1) + transformedType.substr(type.length - 1).toLowerCase();
  }

  return transformedType;
};

var getContentTypeName = function getContentTypeName(alternateContentType, t, typeCase) {
  var plural = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};

  if (!t) {
    return t;
  }

  var type = t.toLowerCase();

  if (!alternateContentType || !typeAlternates[type]) {
    return getCase(plural.plural ? typeAlternates[type] ? typeAlternates[type].plural : type : type, typeCase, plural);
  }

  var transformedType = getCase(typeAlternates[type] ? plural.plural ? typeAlternates[type].alternatePlural : typeAlternates[type].alternate : type, typeCase, plural);
  return transformedType;
};

var contentType = getContentTypeName;
exports.contentType = contentType;
var _default = getContentTypeName;
exports.default = _default;